module.exports = __webpack_public_path__ + "6627ae827082a0c484c58b375f4b4338.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/warhammer.jpg
// module id = 190
// module chunks = 0